
import { getMetricsApiPrefix, metricsFetch } from '../../config/EnvData';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import React, { useState, useEffect, useRef } from "react";
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Plot from 'react-plotly.js';
import styled from "styled-components";
import { EpochDataBlock, PlotSectionDiv } from '../../components/DisplayComponents';
import {PlotLoadingOverlay} from '../../components/PlotLoadingOverlay';

import Slider from '@mui/material/Slider';
import AirportCarousel from '../../components/AirportCarousel';
import { roundToNthNearestMinute } from "../../utils/funcs.js"
import { createTheme, ThemeProvider } from '@mui/material/styles';

const DEG_TO_NM = 60.0405
const NM_TO_DEG = 1 / DEG_TO_NM

// const DetailedSummaryOverlayDivStyle = styled.div`
// position: fixed;
// text-align:center;
// justify:center;
// display:block;
// flex: none;
// top:0;
// bottom:0;
// left:0;
// right:0;
// padding-top:10%;
// width: 100%;
// height: 100%;
// background-color: rgba(0,0,0,0.5); 
// z-index: 17; 
// cursor: pointer;
// `;

// const OverlaychartPlotDivStyle = styled.div`
// display:block;
// flex:none;
// justify-content: center;
// align-items: center;
// `;

// const DetailedSummaryOverlayDiv = ()=>{
// return(
// <div style={{position:"fixed",zIndex:15}} >
// <DetailedSummaryOverlayDivStyle>
// <OverlaychartPlotDivStyle id="overlayPlot" onClick={handleOverlayClick}>
// <Plot  data={[{
// x: encroachmentData.epochString,
// y: encroachmentData.encrDur.Total,
// type: 'scatter',
// mode: 'lines+markers',
// marker: {color: 'red'},
// },
// ]}
// id="chartPlotDiv"
// layout={ {title: 'Detailed Summary',width:600,height:400} }
// />
// </OverlaychartPlotDivStyle>
// </DetailedSummaryOverlayDivStyle>
// </div>
// );
// };
function getPercentile(arr, percentile) {
  const sorted = [...arr].sort((a, b) => a - b);
  const index = (percentile / 100) * (sorted.length - 1);
  const lower = Math.floor(index);
  const upper = Math.ceil(index);
  const weight = index - lower;

  if (upper === lower) return sorted[index];
  return (1 - weight) * sorted[lower] + weight * sorted[upper];
}
const Layout = styled.div`
    display:flex;
    flex:1 1;
    width:100vh;
    justify-content:flex-start;
    flex-wrap:wrap;
    gap: 10px 10px;
    max-height: calc(100vh - 150px);
`;


const TitleDiv = styled.div`
    min-width:85vw;
`;

const colorPalette = ['#2E91E5', '#E15F99', '#1CA71C', '#FB0D0D', '#DA16FF', '#222A2A', '#B68100', '#750D86', '#EB663B', '#511CFB',
  '#FB0D0D', '#DA16FF', '#222A2A']
const zoomPlusEvent = new KeyboardEvent('keydown', {
  key: '+',           // The key value ('+' for plus)
  code: 'Equal',      // The physical key code (often 'Equal' for '+')
  keyCode: 187,       // The keyCode for '=' which also serves as '+'
  which: 187,         // The which value, same as keyCode
  ctrlKey: true,      // Indicates that Ctrl is pressed
  shiftKey: true,     // Shift is usually needed for the '+' sign
  bubbles: true,      // If the event should bubble up through the DOM
  cancelable: true    // If the event is cancelable
});

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

const zoomMinusEvent = new KeyboardEvent('keydown', {
  key: '-',           // The key value ('+' for plus)
  code: 'Equal',      // The physical key code (often 'Equal' for '+')
  keyCode: 187,       // The keyCode for '=' which also serves as '+'
  which: 187,         // The which value, same as keyCode
  ctrlKey: true,      // Indicates that Ctrl is pressed
  shiftKey: true,     // Shift is usually needed for the '+' sign
  bubbles: true,      // If the event should bubble up through the DOM
  cancelable: true    // If the event is cancelable
});

// <TitleDiv>
// <h1 style={{marginLeft:'10px'}}>{airport+', '+airportData['city']+' - Mashup Dashboard'}</h1>
// </TitleDiv>

const homePlotlyIcon = {
  width: 928.6,
  height: 1000,
  path: 'm786 296v-267q0-15-11-26t-25-10h-214v214h-143v-214h-214q-15 0-25 10t-11 26v267q0 1 0 2t0 2l321 264 321-264q1-1 1-4z m124 39l-34-41q-5-5-12-6h-2q-7 0-12 3l-386 322-386-322q-7-4-13-4-7 2-12 7l-35 41q-4 5-3 13t6 12l401 334q18 15 42 15t43-15l136-114v109q0 8 5 13t13 5h107q8 0 13-5t5-13v-227l122-102q5-5 6-12t-4-13z',
  transform: 'matrix(1 0 0 -1 0 850)'
}

const sliderMarks = [
  {
    value: 0,
    label: '5 min',
  },
  {
    value: 1,
    label: '1 hour',
  },
  {
    value: 2,
    label: '24 hours',
  },
];
const EPOCH_VIEWS = ['map', 'distribution']
const axesLineColor = '#FFFF'//'rgba(220,232,247,0.1)'
const axesLineWidth = 5
function deleteObjectKey(obj, key) {
  // Check if the key exists in the object
  if (obj.hasOwnProperty(key)) {
    // Delete the specified key from the object
    delete obj[key];
  }
  // Return the modified object)
  return obj;
}

function correctAirportFormat(arptObj) {
  return (arptObj['airport'].toUpperCase());
};
function correctAirportQueryFormat(airportString) {
  return ('K' + airportString.toUpperCase());
}
const Encroachments = ({ setTitle, pageTitle, metricLookBackHorizonDays, backendApiPrefix }) => {
  const airport = correctAirportFormat(useParams())
  const [isChartLoading,setIsChartLoading] = useState(true)
  const [isMapLoading,setIsMapLoading] = useState(true)
  const [queryIterTime, setQueryIterTime] = useState(new Date())
  const [metricStartTime, setMetricStartTime] = useState(new Date(new Date().getTime() - metricLookBackHorizonDays * 24 * 60 * 60 * 1000))
  const [airportMapTrace, setAirportMapTrace] = useState({
    type: "scattermapbox",
    lat: [],
    lon: [],
    text: [],
    textfont: { size: 16, color: 'black' },
    textposition: 'top right',
    marker: { symbol: 'marker', color: "black", size: 10, allowoverlap: true },
    hoverinfo: 'skip',
    name: '',
    mode: 'markers+text',
    hovertemplate: '<extra></extra>',
    showlegend: false
  })

  const [conflictTracksTrace, setConflictTracksTrace] = useState({
    type: "scattermapbox",
    lat: [],
    lon: [],
    text: [],
    customdata: [],
    marker: { color: "red", size: 5 },
    opacity: 0.3,
    hovertemplate: '<extra></extra><b>Lat</b>:%{lat:.2f} <b>Lon</b>:%{lon:.2f} <b>Alt</b>:%{text:.0f}ft<br>' +
      '<b>AC</b>: %{customdata[0]}, <b>Conflict AC</b>: %{customdata[1]}<br>' +
      '<b>Conformance Cat.</b>: %{customdata[2]}<br>' +
      '<b>Airspace Class</b>: %{customdata[3]}',
    hoverlabel: { bgcolor: 'white' },
    showlegend: false
  })
  const [statsNumAC, setStatsNumAC] = useState([])
  const [statsAdjEncrDur, setStatsAdjEncrDur] = useState([])

  useEffect(() => {
    setTitle(pageTitle => 'Buffer Encroachments - ' + airport)
    axios.post(backendApiPrefix + '/api/get-airport-data/', { airport: airport })
      .then(response => {
        var jsonData = response.data.message
        console.log(jsonData)
        setAirportData(jsonData)
      })
      .catch(error => {
        console.log(error);
      });
    var encrDataStats_api = getMetricsApiPrefix() +
      'metroplex-buffer-encroachments/get-encroachment-stats?airport=' + airport
    axios.get(encrDataStats_api)
      .then(response => {
        var jsonData = response.data
        setStatsNumAC(jsonData.numAC)
        setStatsAdjEncrDur(jsonData.adjustedEncrDur)
      })
      .catch(error => {
        console.log(error)
      })
    setConflictTracksTrace({
      ...conflictTracksTrace,
      lat: [], lon: [], text: [], customdata: []
    })

  }, [airport]);
  // {

  //     name: 'color toggler',

  //     icon: icon1,

  //     click: function(gd) {

  //         var newColor = colors[Math.floor(3 * Math.random())]

  //         Plotly.restyle(gd, 'line.color', newColor)

  //     }},
  const [airportData, setAirportData] = useState({ 'location': [], 'city': '' });
  const [latestEpochFlag, setLatestEpochFlag] = useState(true)


  const [selectedEpoch, setSelectedEpoch] = useState('')
  const [selectedNumAC, setSelectedNumAC] = useState([])
  const [selectedAdjustedEncrDur, setSelectedAdjustedEncrDur] = useState([])

  const [selectedValues, setSelectedValues] = useState({ encrConfDur: {}, encrDurByAcType: {}, encrDurByAirspaceClass: {} })


  const [lastUpdatedTime, setLastUpdatedTime] = useState(new Date())

  const [epochString, setEpochString] = useState([])
  const [numACTotal, setNumACTotal] = useState([])
  const [numArrACTotal, setNumArrACTotal] = useState([])
  const [numACAirportWise, setNumACAirportWise] = useState([])
  const [numArrACAirportWise, setNumArrACAirportWise] = useState([])
  const [totalEncrDur, setTotalEncrDur] = useState([])
  const [adjustedEncrDur, setAdjustedEncrDur] = useState([])

  const [encrDurByAcType, setEncrDurByAcType] = useState([])
  const [encrDurByAirspaceClass, setEncrDurAirspaceClass] = useState([])

  // const [CommComEncrDur,setCommCommEncrDur] = useState([])
  // const [CommGaEncrDur,setCommGaEncrDur]  = useState([])
  // const [GaGaEncrDur,setGaGaEncrDur] = useState([])

  const [encrConfDur, setEncrConfDur] = useState([])
  const [TotalEncrCounts, setTotalEncrCounts] = useState([])

  const handleLatestEpochButton = () => {
    setLatestEpochFlag(true)
    setSelectedEpoch(epochString[epochString.length - 1])
    setSelectedNumAC(numACTotal[numACTotal.length - 1])
    setSelectedAdjustedEncrDur(adjustedEncrDur[adjustedEncrDur.length - 1])
    setSelectedValues({
      encrConfDur: encrConfDur[encrConfDur.length - 1],
      encrDurByAcType: encrDurByAcType[encrDurByAcType.length - 1],
      encrDurByAirspaceClass: encrDurByAirspaceClass[encrDurByAirspaceClass.length - 1]
    })

    setPlotChartLayout({
      ...plotChartLayout,
      yaxis: {
        ...plotChartLayout.yaxis,
        range: [0, 1.2 * Math.max(...numACTotal)]
      },
      yaxis2: {
        ...plotChartLayout.yaxis2,
        range: [0, 1.2 * Math.max(...totalEncrDur)]
      }
    })
    fetchAndUpdateConflictTracks(epochString[epochString.length - 1])

  };

  const [plotMapLayout, setPlotMapLayout] = useState({
    mapbox:
    {
      style: "light",
      center: { lat: null, lon: null },
      bounds: {
        'north': null,
        'east': null,
        'south': null,
        'west': null
      },
      zoom: 7,
      accesstoken: "pk.eyJ1IjoidmFydW5zdWRhcnNhbmFuIiwiYSI6ImNscmpiazJ0cDAxb2IyaXFiaWQxY2hobHgifQ.oFJXYhV7inwFB3TeBwa86g",
      domain: { 'x': [0.01, 1], 'y': [0.01, 0.99] }
    },
    margin: { l: 10, t: 10, r: 12, b: 10 },
    xaxis: { showline: true, linewidth: 10, linecolor: 'black', mirror: true },
    yaxis: { showline: true, linewidth: 10, linecolor: 'black', mirror: true },
    showlegend: false, plot_bgcolor: 'rgba(220,232,247,0.4)'
  },
  );

  const [plotChartLayout, setPlotChartLayout] = useState({
    grid: { rows: 3, columns: 1 },
    xaxis: {
      anchor: ('y', 'y2'),
      zeroline: false,
      font: { family: 'Inter' },
      rangeselector: {
        x: 0, y: 1.02,
        xanchor: 'left',
        buttons: [{ count: 1, label: '1hr', step: 'hour', stepmode: 'backward' },
        { count: 12, label: '12hrs', step: 'hour', stepmode: 'backward' },
        { count: 1, label: '1d', step: 'day', stepmode: 'backward' },
        { step: 'all' }]
      },
      type: 'date',
      showticklabels: true,
      nticks: 8, mirror: 'all', showline: true, linecolor: axesLineColor, linewidth: axesLineWidth,
      tickfont: { size: 10 }, range: [],
      autorange: true
    },
    yaxis: {
      anchor: 'x2', title: { text: 'NumAC', standoff: 10, font: { size: 12 } }, automargin: true, zeroline: false, domain: [0.78, 1], range: [], showticklabels: true, autorange: false,
      mirror: 'all', showline: true, linecolor: axesLineColor, linewidth: axesLineWidth, fixedrange: true
    },
    legend: { x: 0, xanchor: 'left', y: 1.02, bgcolor: 'rgba(0,0,0,0)', orientation: 'h' },
    //xaxis2:{showticklabels:true},
    xaxis2: {
      zeroline: false, showticklabels: true, tickfont: { size: 12 }, tickangle: 0, range: [epochString[0],
      epochString[epochString.length - 1]]
    },
    yaxis2: {
      anchor: 'x2', title: { text: 'Encr. Dur. [s]', standoff: 10, font: { size: 12 } }, automargin: true, zeroline: false, domain: [0.5, 0.74], range: [], showticklabels: true, autorange: false,
      mirror: 'all', showline: true, linecolor: axesLineColor, linewidth: axesLineWidth, fixedrange: true
    },
    xaxis3: { anchor: 'y3', title: { text: 'Aircraft Categories', font: { size: 12 } }, tickfont: { size: 9 }, zeroline: false, domain: [0.0, 0.27], tickangle: 0, fixedrange: true },
    yaxis3: { anchor: 'x3', title: { text: 'Encr. Dur. [s]', standoff: 10, font: { size: 12 } }, automargin: true, range: [], zeroline: false, domain: [0.03, 0.36], rangemode: "nonnegative", fixedrange: true },
    xaxis4: { title: { text: 'Airspace Classes', font: { size: 12 } }, anchor: 'y4', tickfont: { size: 10 }, zeroline: false, domain: [0.38, 0.65], fixedrange: true },
    yaxis4: { anchor: 'x4', zeroline: false, domain: [0.03, 0.36], range: [], rangemode: "nonnegative", fixedrange: true },
    xaxis6: { title: { text: 'Conformance Categories', font: { size: 12 } }, anchor: 'y6', tickfont: { size: 10 }, zeroline: false, domain: [0.73, 1], fixedrange: true },
    yaxis6: { anchor: 'x6', zeroline: false, domain: [0.03, 0.36], range: [], rangemode: "nonnegative", fixedrange: true },
    annotations: [],
    margin: { t: 54, r: 2, b: 10 },
    height: 640,
    hovermode: 'x unified',
    plot_bgcolor: 'rgba(220,232,247,0.4)'
  });

  const [plotDistributionLayout, setPlotDistributionLayout] = useState({
    showlegend: false,
    autosize: false,
    height: 550,
    margin: { t: 50},
    hovermode: 'closest',
    bargap: 0,
    xaxis: {
      domain: [0, 0.85],
      title:{text:'NumAC'},
      showgrid: false,
      zeroline: false
    },
    yaxis: {
      domain: [0, 0.85],
      title:{text:'Adj. Encr Dur [s]'},
      showgrid: false,
      zeroline: false,
      range:[0,80]
    },
    xaxis2: {
      domain: [0.85, 1.1],
      showgrid: false,
      zeroline: false
    },

    yaxis2: {
      domain: [0.85, 1.1],
      showgrid: false,
      zeroline: false
    }
  });
function removeAtFilteredIndices(sourceArray, filterArray, filterFn) {
    return sourceArray.filter((_, index) => !filterFn(filterArray[index]));
  }
  
function resetMapView() {
  console.log("RESET")
  setPlotMapLayout({
    ...plotMapLayout,
    mapbox: {
      ...plotMapLayout.mapbox,
      center: {
        lat: airportData['location'][0],
        lon: airportData['location'][1]
      },
      bounds: {
        'north': airportData['location'][0] + 200 * NM_TO_DEG,
        'east': airportData['location'][1] + 200 * NM_TO_DEG,
        'south': airportData['location'][0] - 200 * NM_TO_DEG,
        'west': airportData['location'][1] - 200 * NM_TO_DEG
      },
      zoom: 10
    }
  })
};

// const [plotConfig,setPlotConfig] = useState({modeBarButtonsToRemove:['toImage','zoom2d',
//     'toggleSpikelines','select2d',
//     'zoomIn2d','zoomOut2d','lasso2d',
//     'pan2d','autoScale2d', 'resetScale2d','hoverClosestCartesian',
//     'hoverCompareCartesian','zoom3d','pan3d', 'resetCameraDefault3d',
//     'resetCameraLastSave3d', 'hoverClosest3d', 'orbitRotation', 
//     'tableRotation', 'zoomInGeo', 'zoomOutGeo', 'resetGeo', 
//     'hoverClosestGeo', 'toImage', 'sendDataToCloud', 'hoverClosestGl2d',
//     'hoverClosestPie', 'toggleHover', 'resetViews', 'toggleSpikelines', 'resetViewMapbox'],
//      displaylogo:false,responsive:true})

const [plotConfig, setPlotConfig] = useState({
  modeBarButtonsToRemove: ['toImage', 'zoom2d',
    'toggleSpikelines', 'select2d',
    'zoomIn2d', 'zoomOut2d', 'lasso2d',
    'pan2d', 'autoScale2d', 'resetScale2d', 'hoverClosestCartesian',
    'hoverCompareCartesian', 'zoom3d', 'pan3d', 'resetCameraDefault3d',
    'resetCameraLastSave3d', 'hoverClosest3d', 'orbitRotation',
    'tableRotation', 'zoomInGeo', 'zoomOutGeo', 'resetGeo',
    'hoverClosestGeo', 'toImage', 'sendDataToCloud', 'hoverClosestGl2d',
    'hoverClosestPie', 'toggleHover', 'resetViews', 'toggleSpikelines', 'resetViewMapbox'],
  displaylogo: false, responsive: true
})


const [leftDivHeight, setLeftDivHeight] = useState(null);
const [leftDivWidth, setLeftDivWidth] = useState(null);

const [rightDivHeight, setRightDivHeight] = useState(null);
const [rightDivWidth, setRightDivWidth] = useState(null);

const [revKey, setRevKey] = useState(0);

useEffect(() => {
  setTimeout(() => {
    setPlotChartLayout({
      ...plotChartLayout,
      width: 0.98 * leftDivWidth,
      xaxis: {
        ...plotChartLayout.xaxis,
        nticks: Math.round(leftDivWidth / 100)
      }
    });

    setPlotDistributionLayout({
      ...plotDistributionLayout,
      width: 0.98 * rightDivWidth,
      xaxis: {
        ...plotDistributionLayout.xaxis,
        nticks: Math.round(rightDivWidth / 100)
      }
    });

    // setPlotMapLayout({...plotMapLayout,
    // width:0.98*rightDivWidth,
    // });

    setPlotMapLayout({
      ...plotMapLayout,
      width: 0.98 * rightDivWidth,
      mapbox: {
        ...plotMapLayout.mapbox,
        center: {
          lat: airportData['location'][0],
          lon: airportData['location'][1]
        },
        bounds: {
          'north': airportData['location'][0] + 200 * NM_TO_DEG,
          'east': airportData['location'][1] + 200 * NM_TO_DEG,
          'south': airportData['location'][0] - 200 * NM_TO_DEG,
          'west': airportData['location'][1] - 200 * NM_TO_DEG
        },
        attributionControl: false
      },
      zoom: 7
    });

    setAirportMapTrace({
      ...airportMapTrace,
      lat: [airportData['location'][0]],
      lon: [airportData['location'][1]],
      text: [airport],
      name: airport,
      hovertemplate: '<extra></extra>' + airport,
    })

  }, 20)
}, [leftDivWidth, rightDivWidth, airportData]);

useEffect(() => {
  setPlotChartLayout({
    ...plotChartLayout,
    yaxis: {
      ...plotChartLayout.yaxis,
      range: [0, 1.2 * Math.max(...numACTotal)]
    },
    yaxis2: {
      ...plotChartLayout.yaxis2,
      range: [0, 1.2 * Math.max(...totalEncrDur)]
    }
  })
}, [airport])

useEffect(() => {
  const QUERY_CHUNK_HOURS = 4;
  if (queryIterTime.getTime() >= metricStartTime.getTime()) {
    var queryEndTime = queryIterTime
    var shiftedQueryIterTime = new Date(queryIterTime.getTime() - QUERY_CHUNK_HOURS * 60 * 60 * 1000)
    var queryEndTimeComps = queryEndTime.toUTCString().split(/-| |:/)
    var queryEndTimeForAPIQuery = queryEndTimeComps[3] + queryEndTimeComps[2] + queryEndTimeComps[1] + queryEndTimeComps[4] + queryEndTimeComps[5]

    var queryStartTimeComps = shiftedQueryIterTime.toUTCString().split(/-| |:/)
    var queryStartTimeForAPIQuery = queryStartTimeComps[3] + queryStartTimeComps[2] + queryStartTimeComps[1] + queryStartTimeComps[4] + queryStartTimeComps[5]
    axios.post(backendApiPrefix + '/api/get-encroachments-data/', { airport: airport, from: queryStartTimeForAPIQuery, to: queryEndTimeForAPIQuery })
      .then(response => {

        var jsonData = response.data.message
        setQueryIterTime(shiftedQueryIterTime)

        setEpochString([...jsonData.EpochString, ...epochString])
        setNumACTotal([...jsonData.NumACTotal, ...numACTotal])
        setNumArrACTotal([...jsonData.NumArrACTotal, ...numArrACTotal])
        // setNumACAirportWise([...jsonData.NumACAirportWise,...numACAirportWise])
        // setNumArrACAirportWise([...jsonData.NumArrACAirportWise,...numArrACAirportWise])
        setTotalEncrDur([...jsonData.EncrDur['Total'], ...totalEncrDur])
        setAdjustedEncrDur([...jsonData.EncrDur['Adjusted'], ...adjustedEncrDur])
        // setCommCommEncrDur(jsonData.EncrDur['COMM-COMM'])
        // setCommGaEncrDur(jsonData.EncrDur['COMM-GA'])
        // setGaGaEncrDur(jsonData.EncrDur['GA-GA'])

        setEncrDurByAcType([...jsonData.EncrDurByACType, ...encrDurByAcType])
        setEncrDurAirspaceClass([...jsonData.EncrDurByAirspaceClass, ...encrDurByAirspaceClass])
        setEncrConfDur([...jsonData.EncrConfDur, ...encrConfDur])
        setTotalEncrCounts([...jsonData.EncrCounts['Total'], ...TotalEncrCounts])

        if (latestEpochFlag && selectedEpoch === '') {
          if (epochString.length > 0) {
            setSelectedEpoch(epochString[epochString.length - 1])
            setSelectedValues({
              encrConfDur: encrConfDur[encrConfDur.length - 1],
              encrDurByAcType: encrDurByAcType[encrDurByAcType.length - 1],
              encrDurByAirspaceClass: encrDurByAirspaceClass[encrDurByAirspaceClass.length - 1]
            })
            setSelectedAdjustedEncrDur(adjustedEncrDur[adjustedEncrDur.length - 1])
            setSelectedNumAC(numACTotal[numACTotal.length - 1])
          } else {
            setSelectedEpoch(jsonData.EpochString[jsonData.EpochString.length - 1])
            setSelectedValues({
              encrConfDur: jsonData.EncrConfDur[jsonData.EncrConfDur.length - 1],
              encrDurByAcType: jsonData.EncrDurByACType[jsonData.EncrDurByACType.length - 1],
              encrDurByAirspaceClass: jsonData.EncrDurByAirspaceClass[jsonData.EncrDurByAirspaceClass.length - 1]
            })
            setSelectedAdjustedEncrDur(jsonData.EncrDur.Adjusted[jsonData.EncrDur.Adjusted.length - 1])
            setSelectedNumAC(jsonData.NumACTotal[jsonData.NumACTotal.length - 1])
          }

        }
        console.log(jsonData.NumACTotal[jsonData.NumACTotal.length - 1])
        setPlotChartLayout({
          ...plotChartLayout,
          yaxis: {
            ...plotChartLayout.yaxis,
            range: [0, 1.2 * Math.max(...[...jsonData.NumACTotal, ...numACTotal])]
          },
          yaxis2: {
            ...plotChartLayout.yaxis2,
            range: [0, 1.2 * Math.max(...[...jsonData.EncrDur['Total'], ...totalEncrDur])]
          },
          yaxis3: {
            ...plotChartLayout.yaxis3,
            range: [0, 1.2 * Math.max(...[...jsonData.EncrDur['Total'], ...totalEncrDur])]
          },
          yaxis4: {
            ...plotChartLayout.yaxis4,
            range: [0, 1.2 * Math.max(...[...jsonData.EncrDur['Total'], ...totalEncrDur])]
          },

          width: 0.98 * leftDivWidth
        })
        setIsChartLoading(false)
      })
      .catch(error => {
        console.log(error);
        setIsChartLoading(false)
      });
  }
  else {
    fetchAndUpdateConflictTracks(epochString[epochString.length - 1])
  }
}, [queryIterTime])
useEffect(() => {
  setPlotMapLayout({
    ...plotMapLayout,
    mapbox: {
      ...plotMapLayout.mapbox,
      center: {
        lat: airportData['location'][0],
        lon: airportData['location'][1]
      },
      bounds: {
        'north': airportData['location'][0] + 200 * NM_TO_DEG,
        'east': airportData['location'][1] + 200 * NM_TO_DEG,
        'south': airportData['location'][0] - 200 * NM_TO_DEG,
        'west': airportData['location'][1] - 200 * NM_TO_DEG
      },
      zoom: 7
    }
  });

  setAirportMapTrace({
    ...airportMapTrace,
    lat: [airportData['location'][0]],
    lon: [airportData['location'][1]],
    text: [airport],
    name: airport,
    hovertemplate: '<extra></extra>' + airport,
  })
}, [airportData])

const mounted = useRef();
useEffect(() => {
  if (mounted.current) {
    // Component mounted
    console.log("Updated")
  } else {
    console.log("Mounted")
    mounted.current = true

  }
});
// const chartDiv = useCallback(node => {
// if (node !== null) {
// setLeftDivHeight(node.getBoundingClientRect().height);
// setLeftDivWidth(node.getBoundingClientRect().width);
// console.log("HEIGHT",height)
// console.log("HEIGHT",width)
// }
// }, []);
const [isRefreshing, setIsRefreshing] = useState(false);

useEffect(() => {
  const handleBeforeUnload = (event) => {
    // This will be called on both refresh and page close
    setIsRefreshing(true);
    setRevKey(prevVal => prevVal + 1)
    // The following is necessary for older browsers
    event.preventDefault();
    event.returnValue = '';
  };
  window.addEventListener('load', handleBeforeUnload);
  return () => {
    window.removeEventListener('load', handleBeforeUnload);
  };
});

useEffect(() => {
  const resizeObserver = new ResizeObserver((event) => {
    // Depending on the layout, you may need to swap inlineSize with blockSize
    // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/contentBoxSize
    setLeftDivWidth(event[0].contentBoxSize[0].inlineSize);
    setLeftDivHeight(event[0].contentBoxSize[0].inlineSize);
  });

  resizeObserver.observe(document.getElementById("plotlyChartDiv"));


});

useEffect(() => {
  const resizeObserver = new ResizeObserver((event) => {
    // Depending on the layout, you may need to swap inlineSize with blockSize
    // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/contentBoxSize
    setRightDivWidth(event[0].contentBoxSize[0].inlineSize);
    setRightDivHeight(event[0].contentBoxSize[0].inlineSize);
  });
  if (document.getElementById("plotlyMapDiv")) {
    resizeObserver.observe(document.getElementById("plotlyMapDiv"));
  }
});

useEffect(() => {
  const resizeObserver = new ResizeObserver((event) => {
    // Depending on the layout, you may need to swap inlineSize with blockSize
    // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/contentBoxSize
    setRightDivWidth(event[0].contentBoxSize[0].inlineSize);
    setRightDivHeight(event[0].contentBoxSize[0].inlineSize);
  });
  if (document.getElementById("plotlyHistoricDistDiv")) {
    resizeObserver.observe(document.getElementById("plotlyHistoricDistDiv"));
  }
});
const [menuOption, setMenuOption] = React.useState(1);
const [epochView, setEpochView] = useState(EPOCH_VIEWS[0])

const handleChange = (event: SelectChangeEvent) => {
  setMenuOption(String(event.target.value));
  setEpochView(EPOCH_VIEWS[event.target.value - 1])
};

const fetchAndUpdateConflictTracks = (epochVal) => {
  var epochStringComps = epochVal.split(/-| |:/)
  var epochFormatForAPIQuery = monthNames[parseInt(epochStringComps[1]) - 1] +
    epochStringComps[2] + epochStringComps[3] + epochStringComps[4]

  console.log("Epoch for query")
  console.log(epochFormatForAPIQuery)
  var metroplexConflictData_api = getMetricsApiPrefix() + 'metroplex-buffer-encroachments/conflict-data?' +
    'metroplex=' + airportData.metroplex + '&epoch=' + epochFormatForAPIQuery

  Promise.all([
    metricsFetch(metroplexConflictData_api)
  ]).then(function (responses) {
    // Get a JSON object from each of the responses
    return Promise.all(responses.map(function (response) {
      return response.json();
    }));
  }).then(function (json_data_array) {
    updateConflictTracksOnMap(json_data_array[0])
    setIsMapLoading(false)
  }).catch(error => {
    console.log(error);
    setIsMapLoading(false)
  });
}

function updateConflictTracksOnMap(conflictData) {
  var additionalData = []
  for (var idx in conflictData['Acid_AC1']) {
    additionalData.push([conflictData['Acid_AC1'][idx], conflictData['Acid_AC2'][idx],
    conflictData['ConformanceCat'][idx], conflictData['ConflictAirspaceClass_AC1'][idx]])
  }
  for (var idx in conflictData['Acid_AC2']) {
    additionalData.push([conflictData['Acid_AC2'][idx], conflictData['Acid_AC1'][idx],
    conflictData['ConformanceCat'][idx], conflictData['ConflictAirspaceClass_AC2'][idx]])
  }
  if (conflictData.hasOwnProperty('ConflictLat_AC1')) {
    console.log(conflictData)
    setConflictTracksTrace({
      ...conflictTracksTrace,
      lat: conflictData['ConflictLat_AC1'].concat(conflictData['ConflictLat_AC2']),
      lon: conflictData['ConflictLon_AC1'].concat(conflictData['ConflictLon_AC2']),
      text: conflictData['ConflictAlt_AC1'].concat(conflictData['ConflictAlt_AC2']),
      customdata: additionalData
    })
  } else {
    setConflictTracksTrace({
      ...conflictTracksTrace,
      lat: [], lon: [], text: [], customdata: []
    });
  }
}
const handleDoubleClickOnMap = (data) => {
  setPlotMapLayout({
    ...plotMapLayout,
    mapbox: {
      ...plotMapLayout.mapbox,
      center: {
        lat: airportData['location'][0],
        lon: airportData['location'][1]
      },
      bounds: {
        'north': airportData['location'][0] + 200 * NM_TO_DEG,
        'east': airportData['location'][1] + 200 * NM_TO_DEG,
        'south': airportData['location'][0] - 200 * NM_TO_DEG,
        'west': airportData['location'][1] - 200 * NM_TO_DEG
      },
      zoom: 7
    }
  });
}
const handleClickOnChart = (data) => {
  console.log(data)
  setLatestEpochFlag(false)
  var point = data.points[0]

  if (!(new Date(point.x) instanceof Date && !isNaN(new Date(point.x).valueOf()))) {
    return;
  }
  console.log(point)
  console.log(point.pointIndex)
  console.log(epochString[point.pointIndex])

  setSelectedEpoch(epochString[point.pointIndex])
  setSelectedValues({
    encrConfDur: encrConfDur[point.pointIndex],
    encrDurByAcType: encrDurByAcType[point.pointIndex],
    encrDurByAirspaceClass: encrDurByAirspaceClass[point.pointIndex]
  })
  setSelectedNumAC(numACTotal[point.pointIndex])
  setSelectedAdjustedEncrDur(adjustedEncrDur[point.pointIndex])
  setPlotChartLayout({
    ...plotChartLayout,
    yaxis: {
      ...plotChartLayout.yaxis,
      range: [0, 1.2 * Math.max(...numACTotal)]
    },
    yaxis2: {
      ...plotChartLayout.yaxis2,
      range: [0, 1.2 * Math.max(...totalEncrDur)]
    },
    yaxis3: {
      ...plotChartLayout.yaxis3,
      range: [0, 1.2 * Math.max(...totalEncrDur)]
    },
    yaxis4: {
      ...plotChartLayout.yaxis4,
      range: [0, 1.2 * Math.max(...totalEncrDur)]
    },
    yaxis6: {
      ...plotChartLayout.yaxis6,
      range: [0, 1.2 * Math.max(...totalEncrDur)]
    }
  })

  fetchAndUpdateConflictTracks(epochString[point.pointIndex])
};
function getLatestMetricData() {
  console.log(airportData['metroplex'])
  var bufferEncroachment_api_latest = getMetricsApiPrefix() + 'metroplex-buffer-encroachments?metroplex=' +
    airportData['metroplex'] + '&duration=latest'
  Promise.all([
    metricsFetch(bufferEncroachment_api_latest),
  ]).then(function (responses) {
    // Get a JSON object from each of the responses
    return Promise.all(responses.map(function (response) {
      return response.json();
    }));
  }).then(function (json_data_array) {
    // Log the data to the console
    var jsonData = json_data_array[0]
    if (jsonData.epochString === epochString[epochString.length - 1]) {
      // Not a new epoch
      return;
    }
    setEpochString([...epochString, jsonData.epochString])

    setNumACTotal([...numACTotal, jsonData.numAC.Total])
    setNumArrACTotal([...numArrACTotal, jsonData.numArrAC.Total])
    if (latestEpochFlag) {
      setSelectedEpoch(jsonData.epochString);
      setSelectedNumAC(jsonData.numAC.Total)

      if (jsonData.MetCondition[airport] !== null) {
        if (jsonData.MetCondition[correctAirportQueryFormat(airport)] === 'VMC') {
          setSelectedAdjustedEncrDur(jsonData.confDur.A.Total + jsonData.confDur.B.Total)
        } else {
          setSelectedAdjustedEncrDur(jsonData.encrDur['Total'])
        }
      }
      else {
        setSelectedAdjustedEncrDur(null)
      }

      fetchAndUpdateConflictTracks(jsonData.epochString)
    };


    setTotalEncrDur([...totalEncrDur, jsonData.encrDur['Total']])
    if (jsonData.MetCondition[airport] !== null) {
      if (jsonData.MetCondition[correctAirportQueryFormat(airport)] === 'VMC') {
        setAdjustedEncrDur([...adjustedEncrDur, jsonData.confDur.A.Total + jsonData.confDur.B.Total])
      } else {
        setAdjustedEncrDur([...adjustedEncrDur, jsonData.encrDur['Total']])
      }
    }
    else {
      setAdjustedEncrDur([...adjustedEncrDur, null])
    }
    setEncrDurByAcType([...encrDurByAcType, deleteObjectKey(jsonData.encrDur, 'Total')])
    setEncrDurAirspaceClass([...encrDurByAirspaceClass, Object.keys(jsonData.airspaceClassWiseDur).reduce((acc, key) => {
      acc[key] = jsonData.airspaceClassWiseDur[key]['Total']; return acc
    }, {})])
    setEncrConfDur([...encrConfDur,
    Object.keys(jsonData.confDur).reduce((acc, key) => {
      acc[key] = jsonData.confDur[key]['Total']; return acc
    }, {})])

    setTotalEncrCounts([...TotalEncrCounts, jsonData.encrCounts['Total']])
    // setSelectedPointIndex(jsonData.EpochString.length-1)
    // setSelectedEpoch(jsonData.EpochString[jsonData.EpochString.length-1])
    // console.log(jsonData.NumACTotal[jsonData.NumACTotal.length-1])
    // setPlotChartLayout({...plotChartLayout,
    //     yaxis:{...plotChartLayout.yaxis,
    //              range:[0,1.2*Math.max(...jsonData.NumACTotal)]
    //     },
    //     yaxis2:{...plotChartLayout.yaxis2,
    //                 range:[0,1.2*Math.max(...jsonData.EncrDur['Total'])]},
    //     yaxis3:{...plotChartLayout.yaxis3,
    //                 range:[0,1.2*Math.max(...jsonData.EncrDur['Total'])]},
    //     yaxis4:{...plotChartLayout.yaxis4,
    //                     range:[0,1.2*Math.max(...jsonData.EncrDur['Total'])]},
    // })
  }).catch(function (error) {
    // if there's an error, log it
    console.log(error);
  });
};
var historicScatter = {
  x: statsNumAC,
  y: statsAdjEncrDur,
  mode: 'markers',
  name: 'Historic Samples',
  marker: { color: 'rgb(102,0,0)', size: 2, opacity: 0.4 },
  type: 'scatter',
  hoverinfo:'skip'
};

var selectedNumACAdjEncrDur = {
  x: [selectedNumAC],
  y: [selectedAdjustedEncrDur],
  mode: 'markers',
  name: 'Selected Epoch',
  marker: {color: 'rgba(12,242,22,0.8',size:15},
  type:'scatter',
  hovertemplate:'<extra></extra>Selected Epoch<br>NumAC:%{x}, Adj. Encr Dur:%{y}'
}
var historicDensity = {
  x: statsNumAC,
  y: statsAdjEncrDur,
  name: 'Historic Density',
  ncontours: 20,
  colorscale: 'Hot',
  reversescale: true,
  showscale: false,
  type: 'histogram2dcontour',
  hovertemplate:'<extra></extra>Historic Density<br>NumAC:%{x}, Adj. Encr Dur:%{y}, Frequency:%{z}'
};

var numACDensity = {
  x: statsNumAC,
  name: 'NumAC Density',
  marker: { color: 'rgb(102,0,0)' },
  yaxis: 'y2',
  type: 'histogram',
  hovertemplate:'<extra></extra>NumAC Histogram<br>NumAC Bins:%{x}, Counts:%{y}'
};

var adjEncrDurDensity = {
  y: statsAdjEncrDur,
  name: 'Adj. Encr Dur Density',
  marker: { color: 'rgb(102,0,0)' },
  xaxis: 'x2',
  type: 'histogram',
  hovertemplate:'<extra></extra>Adj. EncrDur Histogram<br>EncrDur Bins:%{y}, Counts:%{x}'
};
useEffect(() => {
  const interval = setInterval(() => {
    setLastUpdatedTime(new Date())
    getLatestMetricData()
  }, 10000);
  return () => clearInterval(interval);
}, [latestEpochFlag, epochString, airportData]);
return (
  <Layout>
    <PlotSectionDiv id="chartPlotDiv" flexRatio={5}>
      <PlotLoadingOverlay show={isChartLoading}/>
      <EpochDataBlock selectedEpoch={selectedEpoch} handleLatestEpochButton={handleLatestEpochButton}
        lastUpdatedTime={lastUpdatedTime} />
      <Plot data={[{
        x: epochString,
        y: numACTotal,
        type: 'scatter',
        mode: 'lines',
        name: 'NumAC',
        hovertemplate: '%{y}<extra>NumAC Total</extra>',
        xaxis: 'x',
        yaxis: 'y',
        showlegend: false
      },
      {
        x: epochString,
        y: numArrACTotal,
        type: 'scatter',
        name: 'NumArrAC Total',
        hovertemplate: '<extra></extra>Arrivals:%{y}',
        xaxis: 'x',
        yaxis: 'y',
        showlegend: false
      },
      {
        x: epochString,
        y: totalEncrDur,
        type: 'scatter',
        name: 'Encroachment Duration',
        hovertemplate: '<extra>Encroachment<br>Duration</extra>%{y}s',
        xaxis: 'x',
        yaxis: 'y2',
        showlegend: false
      },
      {
        x: epochString,
        y: adjustedEncrDur,
        type: 'scatter',
        name: 'Adj. EncrDur',
        hovertemplate: '<extra>Adjusted Encroachment<br>Duration</extra>%{y}s',
        xaxis: 'x',
        yaxis: 'y2',
        showlegend: false
      },
      {
        x: [selectedEpoch, selectedEpoch],
        y: [0, Object.hasOwn(plotChartLayout.yaxis, 'range') ? plotChartLayout.yaxis.range[1] : 1],
        type: 'scatter',
        xaxis: 'x', yaxis: 'y',
        mode: 'lines',
        showlegend: false,
        hoverinfo: 'skip',
        line: { color: 'black', dash: 'dashdot' }
      },
      {
        x: [selectedEpoch, selectedEpoch],
        y: [0, Object.hasOwn(plotChartLayout.yaxis2, 'range') ? plotChartLayout.yaxis2.range[1] : 1],
        type: 'scatter',
        xaxis: 'x', yaxis: 'y2',
        mode: 'lines',
        showlegend: false,
        hoverinfo: 'skip',
        line: { color: 'black', dash: 'dashdot' }
      },
      {
        x: Object.keys(selectedValues.encrDurByAcType),
        y: Object.values(selectedValues.encrDurByAcType),
        type: 'bar',
        xaxis: 'x3',
        yaxis: 'y3',
        width: 0.6,
        name: 'Durations by Aircraft Category',
        marker: { color: 'indianred' },
        hovertemplate: '<extra></extra>Epoch: ' + selectedEpoch +
          '<br>Dur: %{y}s',
        showlegend: false
      },
      {
        x: Object.keys(selectedValues.encrDurByAirspaceClass),
        y: Object.values(selectedValues.encrDurByAirspaceClass),
        type: 'bar',
        xaxis: 'x4',
        yaxis: 'y4',
        width: 0.6,
        name: 'Durations by Airspace Class',
        marker: { color: 'teal' },
        hovertemplate: '<extra></extra>Epoch: ' + selectedEpoch +
          '<br>Dur: %{y}s',
        showlegend: false
      },
      {
        x: Object.keys(selectedValues.encrConfDur),
        y: Object.values(selectedValues.encrConfDur),
        type: 'bar',
        xaxis: 'x6',
        yaxis: 'y6',
        width: 0.6,
        name: 'Conformance Categories',
        marker: { color: 'teal' },
        hovertemplate: '<extra></extra>Epoch: ' + selectedEpoch +
          '<br>Dur: %{y}s',
        showlegend: false
      }
      ]}
        layout={plotChartLayout}
        config={plotConfig}
        divId={'plotlyChartDiv'}
        style={{ minWidth: '300px', height: '95%', position: 'relative' }}
        useResizeHandler={true}
        onClick={handleClickOnChart}
        onDoubleClick={() => { }}
      />
    </PlotSectionDiv>
    <PlotSectionDiv id="mapPlotDiv" key={revKey} flexRatio={3}>
      <PlotLoadingOverlay show={isMapLoading} label="Loading map…"/>
      <Box sx={{ mb: 1, mt: 2, ml: 2, mr: 3 }}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label"></InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={menuOption}
            label=""
            onChange={handleChange}
            sx={{ height: 30 }}
          >
            <MenuItem value={1}>Map View</MenuItem>
            <MenuItem value={2}>Historic Distributions</MenuItem>
          </Select>
        </FormControl>
      </Box>
      {epochView === 'map' && <Plot data={[airportMapTrace, conflictTracksTrace]}
        layout={plotMapLayout}
        config={{ ...plotConfig, scrollZoom: true }}
        useResizeHandler={true}
        divId={'plotlyMapDiv'}
        style={{
          minWidth: '300px', height: '90%', position: 'relative', borderWidth: '2px', color: 'yellow',
          borderSyle: 'solid',
          borderColor: 'black'
        }}
        onDoubleClick={handleDoubleClickOnMap}
      />}
      {epochView === 'distribution' && <Plot data={[numACDensity,adjEncrDurDensity,historicDensity,historicScatter,selectedNumACAdjEncrDur]}
        layout={{...plotDistributionLayout,yaxis:{...plotDistributionLayout.yaxis,range:[0,Math.max(15,getPercentile(statsAdjEncrDur,95))]}}}
        config={plotConfig}
        useResizeHandler={true}
        divId={'plotlyHistoricDistDiv'}
        style={{ minWidth: '300px', height: '90%', position: 'relative' }}
      />}
    </PlotSectionDiv>
  </Layout>
);
};

export default Encroachments